// eslint-disable-next-line no-restricted-imports -- factory called at render time by useTranslation-aware consumers
import { t } from 'i18n/utils'

export const MODAL_MESSAGE_COMPOSER = '@@modals/MODAL_MESSAGE_COMPOSER'

export const SIGNATURE_PROMPT_MODAL = '@@modals/SIGNATURE_PROMPT_MODAL'

export const SIGNATURE_EDITOR_MODAL = '@@modals/SIGNATURE_EDITOR_MODAL'

export const TEMPLATE_MODAL = '@@modals/TEMPLATE_MODAL'

export const EMAIL_MODAL = '@@modals/EMAIL_MODAL'

export const SYNC_EMAIL_MODAL = '@@modals/SYNC_EMAIL_MODAL'

export const IGNORED_EMAIL_SENDERS_MODAL = '@@modals/IGNORED_EMAIL_SENDERS_MODAL'

const defaultPromptsSetup = 'Use a modern tone. Be concise.'

export const PROMPTS = {
  sayHello: `Write an email to say hello. ${defaultPromptsSetup}`,
  bookCall: `Write an email to book a call. ${defaultPromptsSetup}`,
  sayThankYou: `Write an email to say thank you. ${defaultPromptsSetup}`,
  closeDeal: `Write an email to close a deal. ${defaultPromptsSetup}`,
  followUp: `Write an email to follow up. ${defaultPromptsSetup}`,
  rewriteText: 'Rewrite the given text.',
  moreEngaging: 'Rewrite the given text to be more engaging.',
  rephrase: 'Rephrase the given text.',
  extend: 'Extend the given text.',
  shorten: 'Shorten the given text'
}

export const getDefaultPrompts = () => [
  {
    key: 'sayHello',
    icon: 'fas fa-hand-wave',
    content: t('email.prompts.sayHello')
  },
  {
    key: 'followUp',
    icon: 'fas fa-envelopes',
    content: t('email.prompts.followUp')
  },
  {
    key: 'bookCall',
    icon: 'fas fa-phone-alt',
    content: t('email.prompts.bookCall')
  },
  {
    key: 'sayThankYou',
    icon: 'fas fa-hand-holding-heart',
    content: t('email.prompts.sayThankYou')
  },
  {
    key: 'closeDeal',
    icon: 'fas fa-handshake',
    content: t('email.prompts.closeDeal')
  }
]

export const getRewritePrompts = () => [
  {
    key: 'moreEngaging',
    icon: 'fas fa-star',
    content: t('email.prompts.moreEngaging')
  },
  {
    key: 'rephrase',
    icon: 'fas fa-pen',
    content: t('email.prompts.rephrase')
  },
  {
    key: 'extend',
    icon: 'fas fa-keyboard',
    content: t('email.prompts.extend')
  },
  {
    key: 'shorten',
    icon: 'fas fa-compress-alt',
    content: t('email.prompts.shorten')
  }
]

export const AI_EMAIL_PLACEHOLDER_REGEX = /\[.*?\]/
